import { type Org, useOrg, useOrgs } from "@api/org";
import { usePersistedOrg } from "@lib/auth";
import { useEffect } from "react";

export function useActiveOrg(): {
  org: Org | null;
  setOrg: (org: Org) => void;
  loading: boolean;
} {
  const [persistedOrg, setPersistedOrg] = usePersistedOrg();

  const { data: orgs } = useOrgs();

  useEffect(() => {
    if (!persistedOrg && orgs && orgs.length > 0) {
      setPersistedOrg(orgs[0]);
    }
  }, [persistedOrg, orgs, setPersistedOrg]);

  // Always have latest copy of org
  const { data: fetchedOrg } = useOrg(persistedOrg?.id);

  // Persist latest copy of org
  useEffect(() => {
    if (!fetchedOrg) {
      return;
    }
    setPersistedOrg(fetchedOrg);
  }, [fetchedOrg, setPersistedOrg]);

  return {
    org: persistedOrg ?? orgs?.[0] ?? null,
    setOrg: (...args) => {
      setPersistedOrg(...args);
    },
    loading: orgs === undefined,
  };
}

export default useActiveOrg;
